import React from 'react';
import { brand } from '../mock';

// Emblema del footer, girando en 3D real (rotateY + preserve-3d, no un sprite/video).
// Usa la misma imagen estática del logo en ambas caras (front/back) para que, al pasar
// de perfil, no se vea espejeada — es el truco estándar de "coin flip" en CSS. No usa
// WebGL/three.js a propósito: para un disco simple sin sombreado dinámico, CSS 3D da el
// mismo giro con cero dependencias nuevas y sin necesitar fallback (funciona en
// cualquier navegador con soporte de transforms 3D, que es prácticamente todos).
const FooterEmblem3D = () => (
  <div className="q-emblem3d" aria-hidden="true">
    <div className="q-emblem3d__spin">
      <img
        src={brand.logoStatic}
        alt=""
        className="q-emblem3d__face q-emblem3d__face--front"
        draggable={false}
      />
      <img
        src={brand.logoStatic}
        alt=""
        className="q-emblem3d__face q-emblem3d__face--back"
        draggable={false}
      />
    </div>
  </div>
);

export default FooterEmblem3D;
